import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { iBisAuthService, iBisAuthModule, iBisEditUserService } from '@dohu/ibis-auth';
import { iBisCommonModule, iBisGridProperties, iBisUIService, iBisFileService, iBisLanguageService } from '@dohu/ibis-common';
import { iBisNavigationModule } from '@dohu/ibis-navigation';
import { iBisEntityModule } from '@dohu/ibis-entity';

import * as nav from '../assets/navigation.json';
import * as display from '../assets/display.json';
import { environment } from '../environments/environment';
import * as label from '../assets/label.json';
import * as labelDevEx from '../assets/devExtreme.json';
import * as labelExtra from '../assets/label.extra.json';
import * as ui from '../assets/uiCustomize.json';
import * as gridLabel from '@dohu/ibis-common/int/ro/label.json';
import { ProxyService } from './service/proxy.service';
import { DxScrollViewModule } from 'devextreme-angular/ui/scroll-view';
import { DxDrawerModule } from 'devextreme-angular/ui/drawer';
import { DxTreeViewModule } from 'devextreme-angular/ui/tree-view';
import { RoutesComponent } from './view/routes/routes.component';
import { UploadExcelService } from './view/routes/upload-excel/upload-excel.service';
import { UploadExcelComponent } from './view/routes/upload-excel/upload-excel.component';
import { GoogleMapsService } from './service/google-maps.service';
import { AdminModule } from './view/admin/admin.module';
import { RoutesModule } from './view/routes/routes.module';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AdminModule,
    RoutesModule,
    DxScrollViewModule,
    DxDrawerModule,
    DxTreeViewModule,
    iBisAuthModule,
    iBisEntityModule.forRoot({ key: 'id', server: environment.defaultUrlServer }),
    iBisCommonModule.forRoot({
      display: display,
      logo: 'assets/img/popup_logo.png',
      lang: 'ro',
      label: [labelDevEx.default, gridLabel.default, labelExtra.default, label.default],
      grid: ui.default.grid as iBisGridProperties,
      ui: ui.default.ui,
    }, {
      saasServer: environment.saasServer,
      fileServer: environment.saasServer,
      authServer: environment.authServer,
      deployId: environment.deployId,
      useLocalStorage: true,
      skipLocation: false
    }),
    iBisNavigationModule.forRoot({
      navigation: nav.default, shortcut: nav.default.shortcut,
      ignorePath: ['/login', '/resetPassword', '/register', '/confirmInvite'], outer: true
    })],
  providers: [
    ProxyService,
    iBisAuthService,
    iBisEditUserService,
    GoogleMapsService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})



export class AppModule { }